export default __webpack_public_path__ + "static/media/Al Zougour.a05588f3.svg";